import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import configBackground from '../wob-background-menu'
import wobTablePaddingMenu from '../wob-table-padding-menu'
import fontSizeMenu from '../font-size-menu'
import i18n from 'scoreboard/components/i18n'
import TableSettings from 'scoreboard/datasets/overview/table-settings'
import ChooseColumns from 'scoreboard/datasets/overview/choose-columns'
import RepeatByGroupingWizard from 'scoreboard/datasets/overview/repeat-by-grouping-wizard'
import $ from 'jquery'
import ConfigDatasetTableLabel from './config-dataset-table-label'
import WidgetConfigMenu from '../widget-config-menu'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'
import unwrapModel from 'scoreboard/components/unwrap-model'
import { ROLLUP_FIELD_ANCESTORS, ROLLUP_FIELD_KEYS }
	from 'scoreboard/datasets/overview/datasets-tabular-result'
import { getRepeatByGroupingKey } from 'scoreboard/datasets/overview/get-repeat-by-grouping'
import ViewTableDataSource from 'scoreboard/datasets/overview/view-table-data-source'
import updateSimilarTimeRanges from 'scoreboard/datasets/update-similar-time-ranges'
import DomainType from '../../../components/domain-type'
import DataSourceWidgetConfigMenu from '../data-source-widget-config-menu'
const { DATASET } = DomainType

function sortIsValid(unwrappedTable) {
	return	unwrappedTable.sortField && unwrappedTable.ascending != null
}

const DatasetTableWidgetConfig = DataSourceWidgetConfigMenu.extend({

	/** @type {DatasetTableWidget} */
	model: null,

	initialize (options) {
		WidgetConfigMenu.prototype.initialize.apply(this, arguments)
		this.options = options
	},

	render: function() {
		BootslideMenu.prototype.render.apply(this, arguments)
		this.toggleSortMenuItems()

		return this
	},

	typeSpecificTargets: function (hasTemplate) {
		// Note: this will be null if the data source is set to None
		let dataset = this.model.data.datasetModel(this.model.properties.get('datasetId'))

		let genericTargets = [
			{
				type: 'dialog',
				label: 'dashboards.setTitle',
				target: function (e) {
					let configView = new ConfigDatasetTableLabel({
						model: this.model
					})

					appDisplay.dialog(configView)

					e.preventDefault()
					this.trigger('done')
				}.bind(this)
			},
			this.setDataSource(dataset),
			fontSizeMenu(this.model.properties),
			wobTablePaddingMenu(this.model.properties),
			configBackground(this.model.properties)
		]

		if (!dataset || !dataset.get('view')) {
			return genericTargets
		}

		let options
		if (this.options.datasetOptions) {
			// Ideally, we want to use the view options that came from a
			// completed dataset query
			// #43079 don't clone datasetOptions; it's not necessary
			// (dataset-table-widget-view.js
			// already did this) and it can be expensive with large datasets
			options = this.options.datasetOptions

			// override the table that came from the dataset request with the
			// persisted table, since that's what we'll be configuring
			options.table = this.model.table
			// add the aggregations back so that we have their sortField
			// properties for TableSettings
			options.table.sortable = this.options.datasetOptions.table.sortable
			if (options.table.sortable) {
				const aggregations = _.cloneDeep(this.options.datasetOptions.table.get('aggregations'))
				options.table.set({ aggregations })
				options.showSort = true
				options.table.isDefaultAggregations = !!this.options.datasetOptions.table.isDefaultAggregations
			}
		} else {
			// #19229 if the dataset is in error state or the dataset request
			// hasn't returned yet, we won't have the necessary datasetOptions
			// for a lot of the dataset settings.
			//
			// #33388 instead, do our best to reconstruct what the options would
			// have been by using the widget config, so that the menu will at least
			// partially work
			let table = this.model.table
			options = {
				table,
				treeItemsById: this.model.data.datasetTreeItemsById(),
				field: dataset.combinedFieldsById[table.get('fieldId')],
				filters: this.model.filters()
			}
		}

		let settingsModel = TableSettings.SettingsModel.fromOptions(options, dataset)

		// Use the table config menu from Datasets Overview, and pull out the items
		// that are applicable for table widgets
		var tableSettings = new TableSettings({ model: settingsModel })
		let datasetMenu = tableSettings.menu()
		let datasetTargets = []

		function pushIfFound (labelCode, model) {
			let target = _.find(datasetMenu.target, target => target.label === i18n.get(labelCode))
			if (target) {
				if (model) {
					target.model = model
				}
				datasetTargets.push(target)
			}
		}

		pushIfFound('datasets.choose.rows')
		pushIfFound('datasets.choose.columns')
		pushIfFound('datasets.breakdown.columns')
		pushIfFound('datasets.breakdown.rows')

		if (options.table.sortable) {
			pushIfFound('dashboards.datasets.sort', settingsModel)
		}
		pushIfFound('datasets.field.showKeys.short', settingsModel)
		pushIfFound('datasets.field.showAncestors', settingsModel)
		pushIfFound('common.abbreviateNumbers', settingsModel)

		let numResultsOption = _.find(datasetMenu.target, target => {
			return target.contentView && target.contentView.prototype.property === 'numResults'
		})
		if (numResultsOption) {
			datasetTargets.push(numResultsOption)
		}

		let levelsOption = _.find(datasetMenu.target, target => {
			return target.contentView && target.contentView.prototype.property === 'levels'
		})
		if (levelsOption) {
			datasetTargets.push(levelsOption)
		}

		settingsModel.on('change:summaryType', function() {
			this.updateTable(table => {
				const summaryType = settingsModel.get('summaryType')
				if (summaryType) {
					table.set({ summaryType })
					table.unset('breakdownCalendarId')
					// not using options {silent: true} to prevent event emission,
					// because then the view doesnt update and we can have a
					// 'breakdownCalendarId' and a 'row' checked simultaneously
					settingsModel.unset('breakdownCalendarId')
				}
			})
		}.bind(this))

		// the "Choose Rows" option for date fields
		settingsModel.on('change:breakdownCalendarId', function () {
			this.updateTable(table => {
				const breakdownCalendarId = settingsModel.get('breakdownCalendarId')
				if (breakdownCalendarId) {
					table.breakdownCalendarId = breakdownCalendarId
					// #49953 make a single update so event listeners aren't
					// working on partially-updated state
					table.set({
						breakdownCalendarId,
						groupCalendarId: null,
						summaryType: null
					})
					settingsModel.unset('summaryType')
				}
			})
		}.bind(this))

		tableSettings.on('updateSimilarTimeRanges', ({ summaryType, groupCalendarId, breakdownCalendarId }) => {
			this.updateTable(table => {
				updateSimilarTimeRanges({ settingsModel, table,
					summaryType, groupCalendarId, breakdownCalendarId })
			})

			// #49609 TableSettings expects the tooltip to close after clicking Done
			this.trigger('done')
		})

		tableSettings.on('view-data-source', () =>
			this.viewDataSource(dataset, options.table))

		tableSettings.on('choose-columns', () => {
			let xhr = $.get('api/datasets/data-source-info')
			appDisplay.dialog(xhr, ({ datasets }) => {
				var chooseColumns = new ChooseColumns({
					allowAppCalendar: true,
					model: dataset,
					datasets,
					table: options.table,
					treeItemsById: options.treeItemsById
				})
				chooseColumns.on('done', data => {
					this.updateTable(table => {
						table.set(data)
						return table
					})
				})
				return chooseColumns
			})
		})

		let setRepeatByGrouping = (table, repeatByType) => {
			var xhr = $.get('api/datasets/' + dataset.id + '/field-suggestions')
			appDisplay.dialog(xhr, suggestions => {
				const repeatByGroupingWizard = new RepeatByGroupingWizard({
					model: dataset,
					table,
					repeatByType,
					suggestions: suggestions
				})

				repeatByGroupingWizard.on('done', grouping => {
					this.updateTable(table =>
						table.set(getRepeatByGroupingKey(repeatByType), grouping))
				})

				return repeatByGroupingWizard._view()
			})
		}

		tableSettings.on('set-repeat-by-grouping-columns', setRepeatByGrouping.bind(null, options.table, 'column'))
		tableSettings.on('set-repeat-by-grouping-rows', setRepeatByGrouping.bind(null, options.table, 'row'))

		tableSettings.setBootslideWidth = (width, noTransition) => {
			// #49609 Because we aren't using tableSettings directly, but instead
			// pulling bits of it into *this* bootslide menu, the tableSettings
			// call to this.setBootslideWidth() is calling the wrong menu. So
			// we'll just set up proxy for it
			this.setBootslideWidth(width, noTransition)
		}

		// #49883 similar to setBootslideWidth() above, proxy the back() call
		// from tableSettings
		tableSettings.back = () => this.back()

		// hide ancestors and keys in the sort menu after the bootslide menu is rendered
		// refresh the Sort submenu when show keys or show ancestors toggles are clicked
		settingsModel.on('change:showKeys', () => {
			this.updateTable(table => table.set('showKeys', settingsModel.get('showKeys')))
			this.toggleSortMenuItems()
		})

		settingsModel.on('change:showAncestors', () => {
			this.updateTable(table => table.set('showAncestors', settingsModel.get('showAncestors')))
			this.toggleSortMenuItems()
		})

		settingsModel.on('change:abbreviateNumbers', () => {
			this.updateTable(table => table.set('abbreviateNumbers', settingsModel.get('abbreviateNumbers')))
		})

		settingsModel.table.on('change:sortField', (multiChoiceModel) => {
			const sortField = multiChoiceModel.get('sortField')
			this.updateSort(multiChoiceModel, table => table.set({ sortField }))
		})

		settingsModel.table.on('change:ascending', (multiChoiceModel) => {
			this.updateSort(multiChoiceModel, table => table.set('ascending', multiChoiceModel.get('ascending')))
		})

		settingsModel.table.on('change:numResults', (multiChoiceModel) => {
			this.updateTable(table => table.set('numResults', multiChoiceModel.get('numResults')))
		})

		genericTargets.splice(1, 0, {
			// #58057 set type as 'priority-submenu' so it will not get sorted
			// by widget-config-menu to be below the 'Font Size' value-then-submenu
			type: 'priority-submenu',
			width: 250,
			label: i18n.get('dashboards.datasets.datasetOptions'),
			target: datasetTargets
		})

		return genericTargets
	},

	setDataSource: function(dataset) {
		let dataSource = unwrapModel(this.model.table)

		let warningBannerMessage = this.model.isNoneSource()
			// No need to warn about switching dataset if it was None before
			? null
			// #58695 warning message when changing the dataset
			: i18n.get('dashboards.datasets.datasetTable.changeDataset.warning')

		return this.createDataSourceOption({
			model: this.model,
			widgetUpdater: this.options.widgetUpdater,
			allowedDomainTypes: [DATASET],
			dataSourceSelectorOptions: {
				dataset,
				dataSource,
				allowCalculated: false,
				showAggregationType: false,
				includeTotal: false,
				includeNativeTotal: false,
				warningBannerMessage
			}
		})
	},

	/**
	 * @param {Dataset} dataset
	 * @param {DatasetTable} table
	 */
	viewDataSource: function(dataset, table) {
		appDisplay.dialog(new ViewTableDataSource({
			model: dataset,
			table,
			showDatasetLink: true
		}))
	},

	query: function() {
		// Most table widget settings are too granular to reliably apply to
		// multiple table widgets; just apply it to the current widget and
		// trigger a query
		this.options.widgetUpdater.datasetWidgetUpdated(this.model)
	},

	updateTable: function(updateFn, shouldQuery = true) {
		const returned = updateFn(this.model.table)
		this.model.table = returned || this.model.table

		if (shouldQuery) {
			this.query()
			this.model.trigger('change:table')
		}
	},

	updateSort: function(model, updateFn) {
		const unrwappedTable = unwrapModel(model)
		if (_.isNil(unrwappedTable.sortField)) {
			this.updateTable(table => {
				table.unset('sortField')
				// reset the sort order when switching back to the default sort
				table.unset('descending')
			})
			return
		}

		if (sortIsValid(unrwappedTable)) {
			this.updateTable(updateFn)
		} else {
			this.updateTable(updateFn, false)
		}
	},

	toggleSortMenuItems: function() {
		// revert the sort back to Default if we are toggling ancestors or keys off
		// and have them selected as the current sort field
		const showAncestors = this.model.table.get('showAncestors')
		const sortField = this.model.table.get('sortField')
		const showKeys = this.model.table.get('showKeys')
		if ((!showAncestors && sortField === ROLLUP_FIELD_ANCESTORS) ||
			(!showKeys && sortField === ROLLUP_FIELD_KEYS)) {
			this.model.table.unset('sortField')
			this.updateSort(this.model.table)
		}
		this.bootslide.toggleItem('dataset-sort-ancestors', showAncestors)
		this.bootslide.toggleItem('dataset-sort-keys', showKeys)
	}
})

export default DatasetTableWidgetConfig
DatasetTableWidgetConfig.__filename__ = 'dashboards/widgets/dataset-table/dataset-table-widget-config.js'
